<template>
  <button :class="`chat chat--${type}`" type="button" @click="openChat">
    <component
      :is="'chat'"
      class="page-header__icon page-header__icon--right"
    />
    <div class="chat-txt">Chat</div>
  </button>
</template>

<script>
import * as components from '@/icons'
import { EventBus, EVENTS } from '@/services/events/EventBus'

// Now, you can use authenticated API sections.
export default {
  components: {
    ...components
  },
  props: {
    type: {
      type: String,
      default: 'small'
    }
  },
  computed: {
    userProfile () {
      return this.$store.state.userprofile
    }
  },
  methods: {
    hasHistory () {
      return window.history.length > 2
    },
    openChat() {
      window.$crisp.push(['do', 'chat:show'])
      window.$crisp.push(['do', 'chat:open'])
      this.addUserDetailsToCrisp()
    },
    addUserDetailsToCrisp () {
      if(this.userProfile.authenticated) {
        if (this.userProfile.profile.email) {
          window.$crisp.push(["set", "user:email", [this.userProfile.profile.email]])
        }
        if (this.userProfile.profile.first_name || this.userProfile.profile.last_name) {
          window.$crisp.push(["set", "user:nickname", [(this.userProfile.profile.first_name || '') +  (' ' + this.userProfile.profile.last_name || '')]])
        }
        // TODO: Set roomnumber in crisp
        // window.$crisp.push(["set", "user:company", ["Crisp", { url: "https://crisp.chat/", description: "Give your customer experience a human touch.", employment: ["CTO", "Software Engineer"], geolocation: ["FR", "Nantes"] }]])
      }

    }
  },
  mounted() {
    window.$crisp.push(["do", "chat:hide"])
    window.$crisp.push(['on', 'chat:closed', () => {
      window.$crisp.push(['do', 'chat:hide']);
    }])
    EventBus.$on(EVENTS.OpenChat, this.openChat)
  },
  destroyed () {
    EventBus.$off(EVENTS.OpenChat, this.openChat)
  }
}
</script>

<style lang="scss">
.chat {
  &--large {
    position: absolute;
    right: 0;
    padding: 1rem;
    background: color(dark);
    color: color(light);

  }
  button {
    padding: 0;
  }
  svg {
    fill: currentColor;
    height: $page-header-icon-size;
  }
  .chat-txt {
    margin-top: 6px;
  }
}
</style>
